// extracted by mini-css-extract-plugin
module.exports = {"live-search-results":"style_live-search-results__cNLZd","isAllPage":"style_isAllPage__l5DZk"};